export const getGeneralText = state => state.settingsReducer.texts.general
export const getDownloadEverythingText = state => state.settingsReducer.texts.downloadEverything
export const getRunWithLogsText = state => state.settingsReducer.texts.runWithLogs
export const getRunWithDx9Text = state => state.settingsReducer.texts.runWithDX9
export const getMinimizeToTrayText = state => state.settingsReducer.texts.minimizeToTray
export const getLanguageText = state => state.settingsReducer.texts.language
export const getResetText = state => state.settingsReducer.texts.reset
export const getForgetAllAccountsText = state => state.settingsReducer.texts.forgetAllAccounts
export const getForgetAllAccountsTooltipText = state =>
    state.settingsReducer.texts.forgetAllAccountsTooltip
export const getSharedCacheSettingsText = state => state.settingsReducer.texts.sharedCacheSettings
// export const getResetToDefaultsText = state =>
// state.settingsReducer.texts.resetToDefaults
export const getManageApiPermissionsText = state => state.settingsReducer.texts.manageApiPermissions
export const getTestServersText = state => state.settingsReducer.texts.testServers
export const getLaunchOptionsText = state => state.settingsReducer.texts.launchOptions
export const getAutoLaunchOnLoginText = state => state.settingsReducer.texts.autoLaunchOnLogin
export const getAutoLaunchOnLoginTooltipText = state =>
    state.settingsReducer.texts.autoLaunchOnLoginTooltip
export const getAutoLaunchOnStartupText = state => state.settingsReducer.texts.autoLaunchOnStartup
export const getAutoLaunchOnStartupTooltipText = state =>
    state.settingsReducer.texts.autoLaunchOnStartupTooltip
export const getLaunchDelayText = state => state.settingsReducer.texts.launchDelay
export const getSecondsText = state => state.settingsReducer.texts.seconds
export const getConfirmForgetText = state => state.settingsReducer.texts.confirmForget
export const getSettingsSavedTitleText = state => state.settingsReducer.texts.settingSavedTitle
// export const getSettingsSavedMessageText = state =>
// state.settingsReducer.texts.settingSavedMessage
export const getLayoutText = state => state.settingsReducer.texts.layout
export const getLayoutDefaultText = state => state.settingsReducer.texts.layoutDefault
export const getLayoutRightText = state => state.settingsReducer.texts.layoutRight
export const getLayoutLeftText = state => state.settingsReducer.texts.layoutLeft



// WEBPACK FOOTER //
// ./src/features/Settings/data/texts/selectors.js